import { Controller } from "@hotwired/stimulus"

// MED-089: a sub item inherits menu, hostnames and locales from its parent, so
// those inputs hide as soon as a parent is chosen and come back when it is
// cleared. The server copies the parent's values anyway; this only keeps the
// form honest. The select is a select2 (form_select_controller), which fires
// its own events next to the native change.
export default class extends Controller {
  static targets = ["parent", "inherited"]

  connect() {
    this.update = this.update.bind(this)

    if (this.hasParentTarget) {
      this.parentTarget.addEventListener("change", this.update)
      $(this.parentTarget).on("select2:select select2:clear", this.update)
    }

    this.update()
  }

  disconnect() {
    if (this.hasParentTarget) {
      this.parentTarget.removeEventListener("change", this.update)
      $(this.parentTarget).off("select2:select select2:clear", this.update)
    }
  }

  update() {
    const nested = this.hasParentTarget && this.parentTarget.value !== ""

    this.inheritedTargets.forEach((element) => element.classList.toggle("d-none", nested))
  }
}
